import React from 'react';
import GrowthAnalysis from './GrowthAnalysis';

const ShipmentGrowthAnalysis = () => {
    return (
        <div>
            <GrowthAnalysis from="shipment-growth-analysis" />
        </div>
    );
};

export default ShipmentGrowthAnalysis;
